export const substepTitles = {
  es: {
    unfinishedOnboarding: "Tenés un registro sin terminar",
    language: "",
    usCitizenship: "",
    accountHolders: "",
    personalAccount: "Cuenta personal",
    additionalHolder: "Continuemos con los titulares adicionales",
    holdersMarried: "¿Los titulares de la cuenta están casados entre sí?",
  },
  en: {
    unfinishedOnboarding: "Unfinished onboarding",
    language: "",
    usCitizenship: "",
    accountHolders: "",
    personalAccount: "Personal account",
    additionalHolder: "Let's continue with the additional co-owners",
    holdersMarried: "Are the account holders married to each other?",
  },
};

export const title = {
  es: "Antes de empezar",
  en: "Before starting",
};

export const descriptions = {
  es: {
    unfinishedOnboarding: "¿Deseás retomar desde donde lo dejaste?",
    language: "Por favor, seleccioná el idioma en el que prefieras continuar",
    usCitizenship: "¿Es usted ciudadano estadounidense?",
    accountHolders: "¿Cuántos titulares tendrá la cuenta?",
    validation: "",
    additionalHolder:
      "Para completar el proceso de apertura, necesitamos la información de los demás titulares antes de finalizar.",
  },
  en: {
    unfinishedOnboarding: "Would you like to resume from where you left off?",
    language: "Please select the language you would prefer continuing in",
    usCitizenship: "Are you US citizen?",
    accountHolders: "How many Co-owners will the account have?",
    validation: "",
    additionalHolder:
      "To complete the opening process, we need the information of the other holders before finalizing.",
  },
};

export const primaryButtons = {
  es: {
    unfinishedOnboarding: "Retomar registro",
    language: "Continuar",
    usCitizenship: "Sí",
    accountHolders: "Continuar",
    validation: "",
    additionalHolder: "Continuar",
    holdersMarried: "Sí",
  },
  en: {
    unfinishedOnboarding: "Resume onboarding",
    language: "Continue",
    usCitizenship: "Yes",
    accountHolders: "Continue",
    validation: "",
    additionalHolder: "Continue",
    holdersMarried: "Yes",
  },
};

export const secondaryButtons = {
  es: {
    unfinishedOnboarding: "Empezar nuevamente",
    language: "",
    usCitizenship: "No",
    accountHolders: "",
    validation: "",
    holdersMarried: "No",
  },
  en: {
    unfinishedOnboarding: "Start again",
    language: "",
    usCitizenship: "No",
    accountHolders: "",
    validation: "",
    holdersMarried: "No",
  },
};

export const labels = {
  es: {
    language: "",
    accountHolders: "",
    mail: "Mail",
    referred: "Ingrese nombre o mail de la persona que te refirió",
    taxId: "Identificación fiscal (CUIT / CUIL / TAX ID)",
    socialSecurityNumber: "Número de seguridad social (SSN)",
  },
  en: {
    language: "",
    accountHolders: "",
    mail: "Email",
    referred: "Enter the name or email of the person who referred you",
    taxId: "Tax identification (CUIT / CUIL / TAX ID)",
    socialSecurityNumber: "Social Security Number (SSN)",
  },
};

export const placeholders = {
  es: {
    language: "Seleccioná una opción",
    accountHolders: "Seleccioná una opción",
    mail: "direccion@mail.com",
    referred: "ej. Nicolás Echeverría",
    taxId: "XX-XXXXXXXX-X",
    socialSecurityNumber: "XXX-XX-XXXX",
  },
  en: {
    language: "Select an option",
    accountHolders: "Select an option",
    mail: "address@mail.com",
    referred: "e.g. Nicolás Echeverría",
    taxId: "XX-XXXXXXXX-X",
    socialSecurityNumber: "XXX-XX-XXXX",
  },
};
